'use strict';

define('lib/helpers/data-layer',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('data-layer', function (opt) {
    return new Handlebars.SafeString(JSON.stringify(opt));
  });
})
;
